'use client';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper/modules';
import {useTooogleTrack} from 'hooks';
import {FC, useEffect} from 'react';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {getPlayer, setTrackList} from 'store/slices/player.slices';
import styles from './gallary-track.module.scss';
import {AudioPlayerItems} from 'libs/types/audio.types';
import noFoto from 'assets/image/no-photo.png';

interface IProps {
    data?: AudioPlayerItems[] | null;
}

export const GallaryTrack: FC<IProps> = ({data = null}) => {
    const dispatch = useAppDispatch();
    const {trakList} = useAppSelector(getPlayer);
    const {trackNumberSwith, setTrack, activeTrackNum} = useTooogleTrack();

    /* Нужно для рендеренга если нет треклиста,
     * присваивается переданная дата в пропсах */
    let listAudio = (trakList.length > 0 && trakList) || data;

    /* Устанавливаю список треков, и информацию о первом треке */
    useEffect(() => {
        if (trakList.length > 0) {
            listAudio = trakList;
        }

        dispatch(setTrackList(listAudio));
        setTrack(listAudio[activeTrackNum] || listAudio[0])
    }, [listAudio, trakList]);


    /* Получаю информацию о выбранном треке */
    useEffect(() => {
        if (trakList.length <= 0) {
            setTrack(data[activeTrackNum]);
        } else {
            setTrack(trakList[activeTrackNum]);
        }
    }, [data, activeTrackNum]);

    return (
        <article className={styles.content}>
            <Swiper
                modules={[Navigation]}
                className={styles.swiper}
                navigation={{
                    nextEl: `.${styles.next}`,
                    prevEl: `.${styles.prev}`,
                }}
                spaceBetween={25}
                slidesPerView={'auto'}
            >
                <button className={styles.prev}/>
                {!listAudio
                    ? ''
                    : listAudio.map(({media, title}, i) => (
                        <SwiperSlide className={styles.slide} key={i}>
                            <div className={styles.wrap}>
                                <img
                                    onClick={() => trackNumberSwith(i)}
                                    src={
                                        media.images.i1x1?.url ||
                                        media.images.i4x3?.url ||
                                        media.images.i16x7?.url ||
                                        media.images.i16x9?.url ||
                                        noFoto.src
                                    }
                                    alt={title}
                                    className={styles.image}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                {/* Элемент слайдера содержит в себе
              картинку/ссылку на каждый трек в списке */}
                <button className={styles.next}/>
            </Swiper>
        </article>
    );
};
